"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.percentageOf = exports.useFree = exports.totalPrice = exports.realPrice = exports.basePrice = void 0;
/**
 * @description price without VAT and without DISCOUNT
 */
function basePrice(nationality, pricelist, purchases) {
    return purchases //
        .map(purchase => purchase.resolution)
        .reduce((acc, size) => acc +
        (pricelist.prices[size].price -
            percentageOf(pricelist.prices[size].price, pricelist.vats[nationality])), 0);
}
exports.basePrice = basePrice;
/**
 * @description price without VAT and with DISCOUNT
 */
function realPrice(nationality, pricelist, purchases) {
    return purchases
        .map(purchase => [purchase.resolution, useFree(purchase)])
        .reduce((acc, [size, useFree]) => acc +
        (useFree
            ? 0
            : pricelist.prices[size].price -
                percentageOf(pricelist.prices[size].price, pricelist.vats[nationality])), 0);
}
exports.realPrice = realPrice;
/**
 * @description price with VAT and with DISCOUNT
 */
function totalPrice(nationality, pricelist, purchases) {
    return purchases //
        .map(purchase => [purchase.resolution, useFree(purchase)])
        .reduce((acc, [size, useFree]) => acc + (useFree ? 0 : pricelist.prices[size].price), 0);
}
exports.totalPrice = totalPrice;
function useFree(purchase) {
    return 'useFreePurchase' in purchase && purchase.useFreePurchase
        ? purchase.useFreePurchase
        : 'usedFreePurchase' in purchase && purchase.usedFreePurchase
            ? purchase.usedFreePurchase
            : false;
}
exports.useFree = useFree;
/**
 * get percentage of value
 *
 * @param value value to extract percentage
 * @param percentage percentage to extract
 * @returns percentage of value
 */
function percentageOf(value, percentage) {
    return (value * percentage) / 100;
}
exports.percentageOf = percentageOf;
